import gql from 'graphql-tag'

export const QUERY_GET_METRICS = gql`
  query MetricsKpi($initialDate: String!, $finalDate: String!, $units: [ID], $segments: [ID], $products: [String]) {
    metricsKpi(initialDate: $initialDate, finalDate: $finalDate, units: $units, segments: $segments, productIds: $products) {
      revenue {
        value
        date
      }
      average_ticket {
        value
        date
      }
      total_coupons {
        value
        date
      }
      average_items_in_basket {
        value
        date
      }
      loyalty_average_items_in_basket {
        value
        date
      }
      non_loyalty_average_items_in_basket {
        value
        date
      }
      average_product_value {
        value
        date
      }
      loyalty_average_product_value {
        value
        date
      }
      non_loyalty_average_product_value {
        value
        date
      }
      unique_customers {
        value
        date
      }
      average_customer_coupons {
        value
        date
      }
      estimated_total_number_of_customers {
        value
        date
      }
    }
  }
`

export const QUERY_GET_METRICS_BY_UNIT = gql`
  query MetricsKpiByUnits($initialDate: String!, $finalDate: String!, $units: [ID], $segments: [ID], $products: [String]) {
    metricsKpiByUnits(initialDate: $initialDate, finalDate: $finalDate, units: $units, segments: $segments, productIds: $products) {
      unit {
        id_erp
        cnpj
        name
      }
      metrics {
        revenue {
          value
          date
        }
        average_ticket {
          value
          date
        }
        total_coupons {
          value
          date
        }
        average_items_in_basket {
          value
          date
        }
        loyalty_average_items_in_basket {
          value
          date
        }
        non_loyalty_average_items_in_basket {
          value
          date
        }
        average_product_value {
          value
          date
        }
        loyalty_average_product_value {
          value
          date
        }
        non_loyalty_average_product_value {
          value
          date
        }
        unique_customers {
          value
          date
        }
        average_customer_coupons {
          value
          date
        }
        estimated_total_number_of_customers {
          value
          date
        }
      }
    }
  }
`

export const QUERY_GET_METRICS_GRAPHIC = gql`
  query MetricsKpi($initialDate: String!, $finalDate: String!, $units: [ID], $groupBy: MetricGroupBy, $segments: [ID], $products: [String]) {
    metricsKpi(initialDate: $initialDate, finalDate: $finalDate, units: $units, groupBy: $groupBy, segments: $segments, productIds: $products) {
      loyalty_average_items_in_basket {
        value
        date
      }
      non_loyalty_average_items_in_basket {
        value
        date
      }
      loyalty_average_product_value {
        value
        date
      }
      non_loyalty_average_product_value {
        value
        date
      }
      unique_customers {
        value
        date
      }
      average_customer_coupons {
        value
        date
      }
      estimated_total_number_of_customers {
        value
        date
      }
    }
  }
`

export const QUERY_GET_REVENUES_STRATEGIES = gql`
  query RevenueIncreaseStrategies($indicators: [IndicatorType!]!) {
    revenueIncreaseStrategies(indicators: $indicators) {
      _id
      name
      description
      link
      indicators
    }
  }
`

export const QUERY_GET_DETAILS = gql`
  query TotalClientsBelowAverageItemsInBasket(
    $initialDate: String!
    $finalDate: String!
    $referenceInitialDate: String!
    $referenceFinalDate: String!
    $units: [ID]
    $units_configuration: [UnitConfigurationInput]
    $segments: [ID]
    $products: [String]
  ) {
    totalClientsBelowAverageItemsInBasket(
      initialDate: $initialDate
      finalDate: $finalDate
      units: $units
      units_configuration: $units_configuration
      segments: $segments
      products: $products
    )
    totalClientsBelowAverageProductValue(
      initialDate: $initialDate
      finalDate: $finalDate
      units: $units
      units_configuration: $units_configuration
      segments: $segments
      products: $products
    )
    totalClientsBelowAverageCoupons(
      initialDate: $initialDate
      finalDate: $finalDate
      units: $units
      units_configuration: $units_configuration
      segments: $segments
      products: $products
    )
    totalClientsDecreasedAverageItemsInBasket(
      initialDate: $initialDate
      finalDate: $finalDate
      referenceInitialDate: $referenceInitialDate
      referenceFinalDate: $referenceFinalDate
      units: $units
      units_configuration: $units_configuration
      segments: $segments
      products: $products
    )
    totalClientsDecreasedAverageProductValue(
      initialDate: $initialDate
      finalDate: $finalDate
      referenceInitialDate: $referenceInitialDate
      referenceFinalDate: $referenceFinalDate
      units: $units
      units_configuration: $units_configuration
      segments: $segments
      products: $products
    )
    totalClientsNonBuy(
      initialDate: $initialDate
      finalDate: $finalDate
      units: $units
      units_configuration: $units_configuration
      segments: $segments
      products: $products
    ) {
      customer_did_not_bought_in_period
    }
    totalClientsNeverBought(
      initialDate: $initialDate
      finalDate: $finalDate
      units: $units
      units_configuration: $units_configuration
      segments: $segments
      products: $products
    ) {
      customer_never_bought
    }
  }
`
